import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Container, Modal, Row, Button, Spinner } from 'react-bootstrap';
import '../../assets/Styles/SimulationCSS/SliderSim.css';

const MTS_Stops = ({ title, latlng, _isChecked, onClick }) => {
    const [isChecked, setIsChecked] = useState(_isChecked || false);

    useEffect(() => {
        // Sync the local state with the _isChecked prop from the parent
        setIsChecked(_isChecked);
    }, [_isChecked]);

    const handleCheckboxChange = (e) => {
        const checked = e.target.checked;
        setIsChecked(checked);
        // Pass the updated checked value and the stop information to the parent
        onClick();
    };

    return (
        <div id="MTS_Stops_Card">
            <div id="MTS_Stops_Card_Title">
                <input 
                    type="checkbox" 
                    id="card-checkbox" 
                    style={{ marginRight: '8px', accentColor: "#eba329" }} 
                    checked={isChecked} 
                    onChange={handleCheckboxChange}
                    title={isChecked ? "Unselect Stop" : "Select Stop"}
                />
                <label data-lat-lng={latlng} htmlFor={title}>{title}</label>
            </div>
        </div>
    );
};

export default MTS_Stops;